import Breadcrumb from "components/Common/Breadcrumb2"
import OffCanvasFilter from "components/OffCanvasFilter/OffCanvasFilter"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { withTranslation } from "react-i18next"
import { Col, Container, Row } from "reactstrap"
import Cliente from "./Components/Cliente"
import Postado from "./Components/Postado"
import SLAEntrega from "./Components/SLAEntrega"
import SLAProducao from "./Components/SlaProducao"

const Eficiencia = props => {
  document.title = "Eficiencia | Sensetek"

  const [showFilter, setShowFilter] = useState(false)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Eficiência")}
            breadcrumbItems={[{ title: props.t("Indicadores"), path: "#" }]}
          />
          <Row>
            <Col className="d-flex flex-row-reverse">
              <button
                className="btn filter-item noti-icon right-bar-toggle text-end"
                type="button"
                onClick={() => {
                  setShowFilter(true)
                }}
              >
                <i className="bx bx-filter" />
              </button>
              <OffCanvasFilter
                showFilter={showFilter}
                setShowFilter={setShowFilter}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <SLAEntrega />
            </Col>
          </Row>
          <Row>
            <Col>
              <SLAProducao />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
Eficiencia.propTypes = {
  t: PropTypes.any,
}
export default withTranslation()(Eficiencia)
